import { useCallback, useContext } from "react";
import { SignalRContext } from "../context/SignlaRContext";

export const useSignalRConnection = () => {
  const connection = useContext(SignalRContext);

  const events = useCallback(
    (
      onMessageReceived: (
        eventType: string,
        data: any,
        examInstanceId?: string
      ) => void
    ) => {
      if (connection) {
        const handleMonitoringMessage = (username: string, message: string) => {
          console.log("MonitoringMessage", username, message);
          onMessageReceived("status", message);
        };

        const handleReceiveTimeForMonitoring = (
          percentage: string,
          examInstanceId: string
        ) => {
          console.log("RecieveTimeForMonitoring", percentage, examInstanceId);
          onMessageReceived("monitorTime", percentage, examInstanceId);
        };

        const handleRefreshPercentageResponseForMonitoring = (
          examInstanceId: string
        ) => {
          getPercetageForMonitoring(examInstanceId);
          onMessageReceived("refreshPercentage", "", examInstanceId);
        };

        const handleReceivePercentageForMonitoring = (
          percentage: string,
          examInstanceId: string
        ) => {
          onMessageReceived("percentage", percentage, examInstanceId);
        };

        connection.on("MonitoringMessage", handleMonitoringMessage);
        connection.on(
          "RecieveTimeForMonitoring",
          handleReceiveTimeForMonitoring
        );
        connection.on(
          "RefreshPercentageResponseForMonitoring",
          handleRefreshPercentageResponseForMonitoring
        );
        connection.on(
          "RecievePercentageForMonitoring",
          handleReceivePercentageForMonitoring
        );

        return () => {
          connection.off("MonitoringMessage", handleMonitoringMessage);
          connection.off(
            "RecieveTimeForMonitoring",
            handleReceiveTimeForMonitoring
          );
          connection.off(
            "RefreshPercentageResponseForMonitoring",
            handleRefreshPercentageResponseForMonitoring
          );
          connection.off(
            "RecievePercentageForMonitoring",
            handleReceivePercentageForMonitoring
          );
        };
      }
      return () => {};
    },
    [connection]
  );

  const newMessage = (messages: string) => {
    console.log("[SignalR] Sending batch message", { messages, connected: !!connection });
    if (connection) {
      connection.send("SendMessage", "status", messages);
    }
  };

  const joinExamTermMonitoring = useCallback((examTermId: string) => {
    if (connection) {
      connection.send("JoinExamTermMonitoring", examTermId);
    }
  }, [connection]);

  const leaveExamTermMonitoring = useCallback((examTermId: string) => {
    if (connection) {
      connection.send("LeaveExamTermMonitoring", examTermId);
    }
  }, [connection]);

  const getTime = () => {
    if (connection) {
      connection.send("GetTime");
    }
  };

  const getTimeForMonitoring = (examInstanceId: string) => {
    console.log(examInstanceId);

    if (connection) {
      connection
        .send("GetTimeForMonitoring", examInstanceId);
    }
  };

  const getPercetageForMonitoring = (examInstanceId: string) => {
    if (connection) {
      connection
        .send("GetPercentageForMonitoring", examInstanceId);
    }
  };

  const sendPauseSingleParticipantsExamInstance = (
    userId: string,
    message: string
  ) => {
    console.log("[SignalR] Sending PAUSE single", { userId, message, connected: !!connection });
    if (connection) {
      connection.send("SendPauseSingleParticipantsExamInstance", userId, message);
    }
  };

  const sendContinueSingle = (userId: string, message: string) => {
    console.log("[SignalR] Sending CONTINUE single", { userId, message, connected: !!connection });
    if (connection) {
      connection.send("SendContinueSingleParticipantsExamInstance", userId, message);
    }
  };

  const sendDisqualifySingle = (userId: string, message: string) => {
    console.log("[SignalR] Sending DISQUALIFY single", { userId, message, connected: !!connection });
    if (connection) {
      connection.send("SendDisqualifySingleParticipantsExamInstance", userId, message);
    }
  }

  const sendNoShowSingle = (userId: string, message: string) => {
    console.log("[SignalR] Sending NO-SHOW single", { userId, message, connected: !!connection });
    if (connection) {
      connection.send("SendNoShowSingleParticipantsExamInstance", userId, message);
    }
  }

  const sendCheckoutSingle = (userId: string, message: string) => {
    console.log("[SignalR] Sending CHECKOUT single", { userId, message, connected: !!connection });
    if (connection) {
      connection.send("SendCheckOutSingleParticipantsExamInstance", userId, message);
    }
  }

  const sendRegisterSingle = (userId: string, message: string) => {
    console.log("[SignalR] Sending REGISTER single", { userId, message, connected: !!connection });
    if (connection) {
      connection.send("SendRegisterSingleParticipantsExamInstance", userId, message);
    }
  }

  return {
    events,
    newMessage,
    getTime,
    getTimeForMonitoring,
    joinExamTermMonitoring,
    leaveExamTermMonitoring,
    sendPauseSingleParticipantsExamInstance,
    sendContinueSingle,
    sendDisqualifySingle,
    sendNoShowSingle,
    sendCheckoutSingle,
    sendRegisterSingle,
  };
};
